export enum FieldType {
    // custom types
    textInput = 1,
    textArea = 2,
    select = 3,
    date = 4,
    checklist = 5,
    radio = 6,
    emailInput = 7,
    numberInput = 8,
    formattedText = 9,
    formattedTextLink = 10,
    region = 11,
    checkbox = 12,
    mobileNumber = 13,
    address = 14,
    image = 15,
    sectionBreak = 16,
    accountNumber = 17,
    storeInfo = 18,

    // base types for forms
    sentiment = 101,
    title = 102,
    message = 103,
    categories = 104,
    attachment = 106,
    userIdentification = 107,
    formHeader = 108,
    userInfo = 109,
    sendFieldsToTheClientCheckbox = 110, // internal form type

    // system types
    // chatCurrentUrl = 201, // removed

    // internal form fields types
    sendCopyToTheClientCheckbox = 302,
    ccUsers = 303,

    // outlook form fields types
    assignee = 304,
    status = 305,
    inbox = 306,

    // internal form fields types
    outboundEmailAddress = 307,
    bccUsers = 308,

    // survey form fields types
    starRating = 401,

    // product element for Meny
    menyProductName = 20001,
    menyProductDescription = 20002,
    menyProductPrice = 20003,
    menyProductEan = 20004,
    menyProductCategory = 20005,
}
